import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _inherits from "@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/esm/getPrototypeOf";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

import * as Request from "../entries/common/request";
import { BaseApi } from "../core/base-api";
import { makeDataMethod, makeMethod } from "../core/base-api/methods-maker";
export var LoginApi = /*#__PURE__*/function (_BaseApi) {
  _inherits(LoginApi, _BaseApi);

  var _super = _createSuper(LoginApi);

  function LoginApi() {
    _classCallCheck(this, LoginApi);

    return _super.apply(this, arguments);
  }

  return LoginApi;
}(BaseApi);
LoginApi.prototype.google = makeDataMethod({
  method: 'post',
  path: Request.Login.Paths.GoogleLogin
});
LoginApi.prototype.deviceClaim = makeDataMethod({
  method: 'post',
  path: Request.Login.Paths.DeviceClaim
});
LoginApi.prototype.deviceInfo = makeMethod({
  method: 'get',
  path: Request.Login.Paths.DeviceInfo
});